import { useId } from "react";

export const LogoMark = ({ className = "h-9 w-9", dark = false }) => {
  const id = useId().replace(/[:]/g, "");
  const frame = dark ? "#FFFFFF" : "#121316";
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={`tl-${id}`} x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor={dark ? "#FFFFFF" : "#121316"} />
          <stop offset="1" stopColor={dark ? "#FFFFFF" : "#121316"} />
        </linearGradient>
      </defs>
      <path d="M8 10L20 4L32 10V30L20 36L8 30V10Z" stroke={frame} strokeWidth="2.2" fill="none" />
      <path d="M16.5 15.5L26 20L16.5 24.5V15.5Z" fill="#7C3AED" />
    </svg>
  );
};

export const LogoFull = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark dark={dark} className="h-9 w-9" />
    <span className="leading-none">
      <span className={`block font-display text-[15px] font-extrabold uppercase tracking-wide ${dark ? "text-white" : "text-charcoal-900"}`}>
        True Life
      </span>
      <span className={`mt-1 block font-mono text-[9px] uppercase tracking-[0.35em] ${dark ? "text-slate-400" : "text-steel"}`}>
        Entertainment
      </span>
    </span>
  </span>
);

export default LogoMark;
